export const FeaturedImageFragment = (postType: string) => `
fragment FeaturedImageFragment on ${postType} {
  featuredImage {
    node {
      publicId
      altText
      sourceUrl
      description
      mediaDetails {
        meta {
          credit
        }
      }
    }
  }
}
`;
